import createAction from '../../common/services/create-action';

export const RELOAD_PAGE = 'reload-page';

export const reloadPage = createAction(RELOAD_PAGE);
